import { pageConfig } from "@/common/service/page-config";
import { planTypes } from '@/common/constants';

export const isSoftProPlusBundle = () => {
  const { features } = pageConfig?.partnerReferral || {};
  return features?.softBundleConfig?.['config']?.bundleName === 'pro_plus';
}

// contain pro plus(only for us/ca) and soft bundle pro plus(pro + zoom phone)
export const isSimilarProPlusBundle = () => {
  return isSoftProPlusBundle() || pageConfig?.editConfig?.planType === planTypes.ZONE_PRO_PLUS;
}
